/**
 * QuadrantSettings Component
 * Manages titles and theme colors for all 4 quadrants inside SettingsModal
 */
import React from 'react';

export const PRESET_COLORS = [
  { id: 'color-red', label: 'Đỏ' },
  { id: 'color-orange', label: 'Cam' },
  { id: 'color-green', label: 'Xanh lá' },
  { id: 'color-blue', label: 'Xanh dương' },
  { id: 'color-purple', label: 'Tím' },
];

export function QuadrantSettings({ quadrants = [], onUpdateQuadrant }) {
  return (
    <div className="quadrant-settings-pane">
      <p className="settings-pane-desc">
        Tùy chỉnh tiêu đề và màu sắc nhận diện cho từng góc phần tư trong ma trận.
      </p>

      <div className="quadrant-settings-list">
        {quadrants.map((q, idx) => (
          <div key={q.id} className="quadrant-setting-card">
            <div className="quadrant-card-header">
              <span className={`quadrant-badge ${q.color}`}>Góc {idx + 1}</span>
              <span className="quadrant-id-label">Mặc định: Q{idx + 1}</span>
            </div>

            <div className="quadrant-input-group">
              <label className="quadrant-setting-label" htmlFor={`quadrant-title-${q.id}`}>
                Tiêu đề góc phần tư
              </label>
              <input
                id={`quadrant-title-${q.id}`}
                type="text"
                className="quadrant-title-setting-input"
                value={q.title}
                onChange={(e) => onUpdateQuadrant(q.id, 'title', e.target.value)}
                placeholder="Nhập tên góc phần tư..."
              />
            </div>

            <div className="quadrant-color-group">
              <span className="quadrant-setting-label">Màu chủ đạo:</span>
              <div className="color-options" role="radiogroup" aria-label={`Chọn màu góc ${idx + 1}`}>
                {PRESET_COLORS.map((c) => (
                  <button
                    key={c.id}
                    type="button"
                    className={`color-dot ${c.id} ${q.color === c.id ? 'active' : ''}`}
                    onClick={() => onUpdateQuadrant(q.id, 'color', c.id)}
                    title={c.label}
                    aria-label={`Chọn màu ${c.label} cho góc ${idx + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
